import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { openPopup } from "../../../store/popupSlice"
import { Helmet } from "react-helmet-async";
import LyftTeamlogo from "../../cloneApps/LyftClone/LyftTeamlogo";

export default function LandingItalyBanner({data}) {
  const dispatch = useDispatch();
  return (
    <>
      <Helmet>
        <link rel="preload" href="/assets/home/land2-banner.webp" as="image" type="image/webp" />
      </Helmet>
      <section className="land-2-banner header-gap">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <h1 className="heading center-heading">{data.title}</h1>
            </div>
            <div className="col-lg-8 text-center">
              <div className="land2-banner-head">
                <p className="sub-heading">{data.desc}</p>
                <span>{data.demo}</span>
                <div className="land-two-btns landing-italy-button">
                  <Link onClick={() => dispatch(openPopup())} className="default-btn">{data.cta1}</Link>
                  <Link style={{marginLeft:"15px"}} to={"/features/taxi-software"} className="default-btn">{data.cta2}</Link>
                </div>
                <img src={data?.bannerImg || "/assets/home/land2-banner.webp"} alt="banner" className="img-responsive" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="land2-banner-logo">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12 text-center">
              <span>{data.slideText}</span>
            </div>
            <LyftTeamlogo/>
          </div>
        </div>
      </section>
    </>
  )
}
